export default __webpack_public_path__ + "static/media/mapFast.e0296841.svg";